// React Router keeps the scroll position across client-side navigations, which
// lands footer-link clicks mid-page. Reset to the top on every pathname change.
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
